import { render, staticRenderFns } from "./WrestlingBracket.vue?vue&type=template&id=7e7b05d8&scoped=true"
import script from "./WrestlingBracket.vue?vue&type=script&lang=js"
export * from "./WrestlingBracket.vue?vue&type=script&lang=js"
import style0 from "./WrestlingBracket.vue?vue&type=style&index=0&id=7e7b05d8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7b05d8",
  null
  
)

export default component.exports